import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { History } from "history";
import connectApp from "./app/reducer";
import landingpage from "./landingpage/reducers";
import details from "./details/reducer";
import cart from "./cart/reducer";
import widgets from "./widgets/reducer";
import internationalization from "./internationalization/reducer";
import listing from "./listing/reducer";
import connectRemoteConfig from "./remoteConfigs/reducer";
import globalSearch from "./globalSearch/reducer";

const createRootReducer = (
    history: History,
    ssrHeaders?: any,
    cookies?: any,
    asyncReducers?: any,
    remoteConfigs?: { [key: string]: string }
) =>
    combineReducers({
        app: connectApp(ssrHeaders, cookies),
        landingpage,
        cart,
        details,
        widgets,
        listing,
        internationalization,
        globalSearch,
        remoteConfigs: connectRemoteConfig(remoteConfigs),
        router: connectRouter(history),
        ...asyncReducers,
    });

export default createRootReducer;
